/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_PRODUCT_STATUS,
  LOAD_STATUS
} from "./constants"

import {
  loadProductStatusError,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadProductStatus,
  loadProductStatusSuccess,
  loadStatus,
  loadStatusSuccess,
  loadStatusError
} from "./actions"

import {
  loadRecordsMetaData,
 loadProductStatusApi,
 loadStatusApi
} from "./remotes"

function* loadProductStatusSaga() {
  while (true) {
   
    const load = yield race({
      explicitLoad: take(LOAD_PRODUCT_STATUS),
    })

    const { explicitLoad } = load
    const { searchFilter } = explicitLoad || {}
    yield put(loadProductStatus(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadProductStatusApi, searchFilter)
        if (result) {
          yield put(loadProductStatusSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadProductStatusSuccess([]))
          yield put(loadProductStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadProductStatusSuccess([]))
        yield put(
          loadProductStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}



function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
     
      const payload = {mode:"OPERATION"}
      const employee = yield call(loadRecordsMetaData,
        "employee_dropdown_list",
        "post")
     const deliver =  yield call(loadRecordsMetaData,"process_status","post",payload)
      let permissionMetaData = {
        deliverOptions:
        (deliver &&
          deliver.data &&
          deliver.data.length > 0 &&
          deliver.data
            .filter((_) => _.status === 1)
            .map((p) =>
              Object.assign(
                {},
                {
                  label: p.processStatus,
                  value: p.processStatusId,
                  processStatusId: p.processStatusId,
                  colorCode: p.colorCode,
                }
              )
            )) ||
        [],
        employeeOptions:
        (employee &&
          employee.data &&
          employee.data.length > 0 &&
          employee.data

            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.empCode.concat(" - ", c.name),
                  value: c._id,

                }
              )
            )) ||
        [],
      
      }
     
      yield put(loadRecordsMetaDataSuccess(permissionMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
function* loadStatusSaga() {
  while (true) {
   
    const load = yield race({
      explicitLoad: take(LOAD_STATUS),
    })

    const { explicitLoad } = load
    const { statusDetails } = explicitLoad || {}
    yield put(loadStatus(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadStatusApi, statusDetails)
        if (result) {
          yield put(loadStatusSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadStatusSuccess([]))
          yield put(loadStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadStatusSuccess([]))
        yield put(
          loadStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadProductStatusSaga(),
    
    loadRecordsMetaDataSaga(),

    loadStatusSaga()
  ])
}
